<template>
    <div class="payment">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5 border shadow-sm add-rounded">
                <h4 class="mb-3 font-weight-bold kova-text">Select an hourly rate that fits your budget. At Kovatek, we have developers
                vetted and place them on the level of expertise that matches their skills</h4>
                <div class="text-left">
                    <label for="opt1" class="radio text-left">
                        <input type="radio" name="rdo" id="opt1" class="hidden" :value="1" v-model="complexity"/>
                        <span class="label"></span>$10 - $17/hr (Junior)
                    </label><br />
                    
                    <label for="opt2" class="radio text-left">
                        <input type="radio" name="rdo" id="opt2" class="hidden" :value="2" v-model="complexity" />
                        <span class="label"></span>$15 - $30/hr (Intermediate)
                    </label><br />

                    <label for="opt3" class="radio text-left">
                        <input type="radio" name="rdo" id="opt3" class="hidden" :value="3" v-model="complexity"/>
                        <span class="label"></span>$25- $40/hr (Senior)
                    </label><br />

                    <label for="opt4" class="radio text-left">
                        <input type="radio" name="rdo" id="opt4" class="hidden" :value="0" v-model="complexity" />
                        <span class="label"></span>Fixed price per month?
                    </label>
                    <div class="ml-5" v-if="showInput">
                    State it:  <input type="number" class="input" placeholder="1000"/>
                    </div>
                </div>            
                <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right kova-text pt-3 mr-4 mb-5">
                <span>Skip <font-awesome-icon icon="step-forward"></font-awesome-icon></span>
            </div>
        </div>
        
        
 </div>
</template>
<script>
export default {
    name: 'payment',
    data(){
        return {
          complexity: this.$store.state.projects.complexity
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$store.state.projects.complexity = this.complexity;
            this.$router.push('make-job-post')
        },
        skip(){
            this.$router.push('make-job-post')
        }
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}

@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>